__turbopack_context__.v({
  "bannerContainer": "sUUZiW_bannerContainer",
  "offer": "sUUZiW_offer",
  "offerContent": "sUUZiW_offerContent",
  "offerDescription": "sUUZiW_offerDescription",
  "offerTitle": "sUUZiW_offerTitle",
  "offersImageContainer": "sUUZiW_offersImageContainer",
  "pulse": "sUUZiW_pulse",
  "slideIn": "sUUZiW_slideIn",
});
